<template>
    <q-list>
        <q-item>
            <q-item-section no-wrap>
                <q-item-label overline>
                    <span class="text-uppercase">Notifications</span>
                </q-item-label>
            </q-item-section>
            <q-item-section side>
                <mark-all-read-btn
                        v-if="userNotifications.length"
                        class="q-mx-xs"
                        :user-id="userId"
                        @marked-read="$emit('marked-read')"/>
            </q-item-section>
        </q-item>
        <q-separator />
        <user-notification-item
                v-for="userNotification in userNotifications"
                :key="userNotification.id"
                :user-notification="userNotification"
                @marked-one-read="$emit('marked-one-read', $event)"/>
        <q-item v-if="!userNotifications.length">
            <q-item-section>
                <q-item-label caption>No unread notifications.</q-item-label>
            </q-item-section>
        </q-item>
        <q-item dense>
            <q-item-section class="items-center">
                <view-all-notifications-btn :user-id="userId" flat />
            </q-item-section>
        </q-item>
    </q-list>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { UserNotification } from '@/type';
import MarkAllReadBtn from '@/user-notification/MarkAllReadBtn.vue';
import UserNotificationItem from '@/user-notification/UserNotificationItem.vue';
import ViewAllNotificationsBtn from '@/user-notification/ViewAllNotificationsBtn.vue';
import notificationComponentMap from './UserNotifcationMap';

export default defineComponent({
  emits: ['marked-one-read', 'marked-read'],
  props: {
    userId: {
      type: Number,
      required: true,
    },
    userNotifications: {
      type: Array as () => UserNotification[],
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getComponentMap(type: string): string {
      // @ts-ignore
      return notificationComponentMap[type];
    },
  },
  components: {
    'mark-all-read-btn': MarkAllReadBtn,
    'user-notification-item': UserNotificationItem,
    'view-all-notifications-btn': ViewAllNotificationsBtn,
  },
});
</script>
